import React, { Component } from 'react';
import Colors from 'Colors.js';
const colors = new Colors();

class AbstractKey extends Component {
    constructor(props) {
        super(props);
    }

    getTrack(trackNumber) {
        return this.props.sequencerEngine.tracks[trackNumber];
    }

    getSample(trackNumber) {
        let track = this.getTrack(trackNumber);
        return track === undefined ? undefined : track.sample;
    }

    isSample(trackNumber) {
        return this.getSample(trackNumber) !== undefined;
    }

    get key() {
        return this.props.value.toLowerCase();
    }

    isThumbnail(trackNumber) {
        return this.isSample(trackNumber) &&
            this.getSample(trackNumber).getThumbnail() !== '' &&
            this.getSample(trackNumber).getThumbnail() !== undefined;
    }

    getThumbnailURL(trackNumber) {
        return this.getSample(trackNumber).getThumbnail();
    }

    getStyle() {
        var color = 'black';
        var style = {};
        if (this.props.keyMapping !== undefined) {
            let mapping = this.props.keyMapping;
            style.borderBottomColor = colors.getColor(mapping.sliceNumber);
            style.borderBottomStyle = 'solid';
            style.borderBottomWidth = '3px';
            
            if (this.isThumbnail(mapping.trackNumber)) {
                style.backgroundImage = 'url("' + this.getThumbnailURL(mapping.trackNumber) + '")';
                style.backgroundPosition = 'center';
                style.backgroundSize = 'cover';
            } else if (this.isSample(mapping.trackNumber)) {
                style.backgroundColor = this.getSample(mapping.trackNumber).color;
            }
            style.color = 'black';
        }
        return style;
    }
}

export default AbstractKey;
